import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiSkeleton from '@material-ui/lab/Skeleton';

const Skeleton = ({ variant, ...otherProps }) => {
  // Components props
  const skeletonProps = { variant, ...otherProps };

  return (
    <MuiSkeleton {...skeletonProps} />
  );
};

Skeleton.propTypes = {
  variant: PropTypes.oneOf(['text', 'rect', 'circle']),
};

Skeleton.defaultProps = {
  variant: 'rect',
};

export default React.memo(Skeleton);



// WEBPACK FOOTER //
// ./components/core/Skeleton.js